import React, { ReactElement } from "react";

interface Props {}

export function VideoInfoBoxDivider(_: Props): ReactElement {
  return <span className="VideoScreen__infoBoxPadder" />;
}
